import React, { Component } from "react";
import styles from "./styles.scss";
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { Search } from "@material-ui/icons";

class LineCursor {
   posX = 0;
   posY = 0;

   startPosX = 0;
   startPosY = 0;

   lastPointPos = null;

   currentState = null;

   Next() {
      this.startPosX = this.posX;
      this.startPosX = this.posX;
   }
}

class OutcomeGraph extends Component {
   static defaultProps = {
      data: [],
      totalTimeSpanMins: 0,
      sampleRateSecs: 60,
      fromTime: null,
      containerClass: ""
   };
   static propTypes = {
      data: PropTypes.array,
      totalTimeSpanMins: PropTypes.number,
      sampleRateSecs: PropTypes.number,
      containerClass: PropTypes.string,
      fromTime: PropTypes.string
   };

   constructor(props) {
      super(props);
      this.ref = React.createRef();
   }

   shouldComponentUpdate(nextProps) {
      const props = this.props;
      for (var p in nextProps) {
         if (nextProps.hasOwnProperty(p)) {
            if (nextProps[p] !== props[p]) {
               return true;
            }
         }
      }
      return false;
   }
   render() {
      const totalSamples = (this.props.totalTimeSpanMins * 60) / this.props.sampleRateSecs;
      const VIEWBOX_WIDTH = totalSamples;
      const pointWidth = VIEWBOX_WIDTH / totalSamples;
      //make points with width 0.0001 actually visible. Graphics of points may overlap
      const visiblePointWidth = pointWidth * Math.max(1, Math.log10(VIEWBOX_WIDTH / 50) * 10);
      const VB_HEIGHT = Math.ceil(VIEWBOX_WIDTH / 10);
      const fromMoment = moment(this.props.fromTime).add(moment().utcOffset(), "m");

      let cursor = new LineCursor();
      cursor.posY = Math.ceil(VB_HEIGHT / 2);

      let failedLineIds = [];

      const y = VB_HEIGHT / 2;

      const draw = i => {
         //draw the line
         const color = cursor.currentState === 3 ? "#E9393A" : "#2E9BB1";
         const width = cursor.currentState === 3 ? Math.ceil(VB_HEIGHT / 7) : Math.ceil(VB_HEIGHT / 10);

         if (cursor.currentState === 3) {
            // add to failed ids list to rerender on top
            failedLineIds.push(i);
         }

         if (cursor.posX < cursor.startPosX) {
            cursor.posX = cursor.startPosX;
         }

         const line = (
            <path
               key={i}
               id={i}
               d={"M" + cursor.startPosX + "," + cursor.startPosY + " L" + cursor.posX + "," + cursor.posY}
               strokeLinecap="butt"
               stroke={color}
               strokeWidth={width}
            />
         );

         cursor.Next();

         return line;
      };         

      return (
         <div styleName={`_container ${this.props.containerClass}`} ref={this.ref}>
            <svg width="100%" height="50px" viewBox={`0 0 ${VIEWBOX_WIDTH} ${VB_HEIGHT}`} xmlns="http://www.w3.org/2000/svg">
               <path
                  d={`M0 ${Math.ceil(VB_HEIGHT / 2)} L${VIEWBOX_WIDTH} ${Math.ceil(VB_HEIGHT / 2)}`}
                  strokeLinecap="butt"
                  stroke="#D9D9DB"
                  strokeWidth={Math.ceil(VB_HEIGHT / 40)}
               />
                  
               {
                  this.props.data.map((x, i) => {
                     if(x.runState !== 2 && x.runState !== 3) {
                        return null;
                     }
         
                     var startL = moment(x.startSiteLocal);
                     const startDiff = moment.duration(startL.diff(fromMoment)).asMinutes();
                     const startX = pointWidth * startDiff - visiblePointWidth / 2;
                     let endDiff = 0;
                     let endX = 0;
         
                     if(x.endSiteLocal) {
                        var endL = moment(x.endSiteLocal);
                        endDiff = moment.duration(endL.diff(fromMoment)).asMinutes();
                        endX = pointWidth * endDiff - visiblePointWidth / 2;
                     } else {
                        var nowL = moment(Date.now());
                        endDiff = moment.duration(nowL.diff(fromMoment)).asMinutes();
                        endX = pointWidth * endDiff - visiblePointWidth / 2;
                        if(endX > VIEWBOX_WIDTH) {
                           endX = VIEWBOX_WIDTH;
                        }
                     }
                     
                     
                     const color = x.runState === 3 ? "#E9393A" : "#2E9BB1";
                     const width = Math.ceil(VB_HEIGHT / 4);
         
                     return (
                        <path
                           key={i}
                           id={i}
                           d={`M${startX} ${Math.ceil(VB_HEIGHT / 2)} L${endX} ${Math.ceil(VB_HEIGHT / 2)}`}
                           strokeLinecap="butt"
                           stroke={color}
                           strokeWidth={width}
                        />
                     )
                  })
               }

               {/*
               {this.props.data.map((x, i) => {
                  if (x.runState !== 2 && x.runState !== 3) {
                     return null;
                  }

                  const diff = moment.duration(moment(x.startSiteLocal).diff(fromMoment)).asMinutes();
                  const diff2 = moment.duration(moment(x.endSiteLocal).diff(fromMoment)).asMinutes();

                  const currentX = pointWidth * diff - visiblePointWidth / 2;
                  let line = null;

                  if (cursor.currentState === null) {
                     cursor.lastPointPos = diff2;
                     cursor.currentState = x.runState;
                     cursor.startPosY = y;
                     cursor.startPosX = currentX;
                  }

                  // if last point is greater that one sample interval + 3% leway OR outcome state differs
                  // OR last point in the array
                  // then draw the line
                  if (
                     cursor.lastPointPos + (this.props.sampleRateSecs / 60 + this.props.sampleRateSecs * 0.03) <
                        diff2 ||
                     x.runState !== cursor.currentState ||
                     i === this.props.data.length - 1
                  ) {
                     //draw the line
                     line = draw(i);
                     //start a new line
                     cursor.currentState = x.runState;
                     cursor.startPosY = y;
                     cursor.startPosX = currentX;
                  } else {
                     cursor.posX = currentX;
                     cursor.posY = y;
                  }

                  cursor.lastPointPos = diff2;
                  return line;
               })}
               */}


               {failedLineIds.map(x => <use key={x} xlinkHref={"#" + x} />)}
            </svg>
         </div>
      );
   }
}

//do this to merge classes
export default class extends Component {
   constructor(props) {
      super(props);
      this.state = {
         wrapped: null
      };
   }

   componentWillMount() {
      this.setState({
         wrapped: CSSModules(
            OutcomeGraph,
            { ...styles, ...this.props.classes },
            {
               allowMultiple: true
            }
         )
      });
   }

   render() {
      const Elem = this.state.wrapped;
      return <Elem {...this.props} />;
   }
}



// WEBPACK FOOTER //
// ./src/components/OutcomeGraph/OutcomeGraph.js